import { render, staticRenderFns } from "./PrkLiteratureElement.vue?vue&type=template&id=51eefbd0&scoped=true&"
import script from "./PrkLiteratureElement.vue?vue&type=script&lang=js&"
export * from "./PrkLiteratureElement.vue?vue&type=script&lang=js&"
import style0 from "./PrkLiteratureElement.vue?vue&type=style&index=0&id=51eefbd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51eefbd0",
  null
  
)

export default component.exports